import { Summary } from "../components/DeclarantGrid/Interfaces";

export default function fillGeneralSummaryData(
  items: Summary[],
  total: { [p: string]: unknown }
): Summary[] {
  return items.map((item) => {
    let general = 0;

    if (total[item.key]) {
      const number = total[item.key] as number | string;

      general = number ? parseFloat(number.toString()) : 0;
    }

    return {
      ...item,
      general,
    };
  });
}
